// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PersonIcon from '@mui/icons-material/Person';
// type
import { NavItemType } from 'types';

const icons = {
    IconDashboard: IconDashboard,
    IconDeviceAnalytics: IconDeviceAnalytics
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const userManagement: NavItemType = {
    id: 'User Management',
    title: <FormattedMessage id="User Management" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'admins',
            title: 'Admin Users',
            type: 'item',
            icon: PersonIcon,
            url: '/admin/list',
            breadcrumbs: false,
            roles: ['admin', 'superAdmin']
        },
        {
            id: 'app-users',
            title: 'App Users',
            type: 'item',
            icon: PhoneAndroidIcon,
            url: '/app-user/list',
            breadcrumbs: false
        }
    ]
};

export default userManagement;
